import { ChangeDetectionStrategy, Component } from '@angular/core';
import { PplDialogRef } from '@ppl/ui/dialog';
import { type DialogResponse } from '@ppl/utils/dialog.utils';


@Component({
  selector: 'ppl-access-blocked-dialog',
  standalone: false,
  templateUrl: './access-blocked-dialog.component.html',
  styleUrl: './access-blocked-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AccessBlockedDialogComponent {
  constructor(
    private dialogRef: PplDialogRef<AccessBlockedDialogComponent, DialogResponse>
  ) { }
}
